import DialogReportsVisits from './Visits';
import DialogReportsDownload from './Download';
import DialogReportsUserSatifaction from './UserSatifaction';
import DialogReportsHeatmap from './Heatmap';

const DialogReportsComponents = {
  Visits: DialogReportsVisits,
  Download: DialogReportsDownload,
  UserSatifaction: DialogReportsUserSatifaction,
  Heatmap: DialogReportsHeatmap,
};

export default DialogReportsComponents;
